module.exports = __webpack_public_path__ + "static/media/student.3c23d20f.png";